// material
import { styled } from "@mui/material/styles";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import MContainer from "components/MContainer";

// ----------------------------------------------------------------------
const SectionTitle = styled(Typography)(({ theme }) => ({
  position: 'relative',
  display: 'inline-block',
  marginBottom: theme.spacing(6),
  textAlign: 'center',
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: '-10px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '60px',
    height: '4px',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '2px',
  }
}));

const FeatureCard = styled(Card)(({ theme }) => ({
  height: '100%',
  borderRadius: '16px',
  overflow: 'hidden',
  boxShadow: '0 6px 20px rgba(0, 0, 0, 0.08)',
  transition: 'transform 0.3s, box-shadow 0.3s',
  background: theme.palette.background.paper,
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: theme.shadows[10],
  },
}));

const FeatureIconContainer = styled(Box)(({ theme }) => ({
  width: '80px',
  height: '80px',
  margin: '0 auto 24px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    width: '60px',
    height: '60px',
    margin: '0 16px 0 0',
  }
}));

export default function Features() {
  return (
    <MContainer id="features" sx={{ 
      position: "relative", 
      mt: 8, 
      pt: 7, 
      pb: 8, 
      backgroundColor: '#f8f9fa',
      borderRadius: { xs: 0, md: '16px' },
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)'
    }}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <SectionTitle variant="h2" color="text.primary">
          Why Choose Us
        </SectionTitle>
      </Box>
      
      <Grid container spacing={4}>          
        <Grid item xs={12} sm={6} md={4}>
          <FeatureCard>
            <CardContent sx={{ p: { xs: 3, md: 4 }, height: '100%', display: 'flex', flexDirection: { xs: 'row', md: 'column' }, alignItems: { xs: 'flex-start', md: 'center' } }}>
              <FeatureIconContainer>
                <Box component="img" src="/images/icons/features/rep.png" sx={{ maxWidth: '100%', maxHeight: '100%' }} />
              </FeatureIconContainer>
              <Box sx={{ textAlign: { xs: 'left', md: 'center' }, width: { xs: 'calc(100% - 76px)', md: '100%' } }}>
                <Typography variant="h5" color="primary.main" sx={{ mb: 2, fontWeight: 600 }}>
                  Dedicated Team
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Our friendly and knowledgeable representatives are ready to handle your shopping needs, saving you valuable time.
                </Typography>
              </Box>
            </CardContent>
          </FeatureCard>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FeatureCard>
            <CardContent sx={{ p: { xs: 3, md: 4 }, height: '100%', display: 'flex', flexDirection: { xs: 'row', md: 'column' }, alignItems: { xs: 'flex-start', md: 'center' } }}>
              <FeatureIconContainer>
                <Box component="img" src="/images/icons/features/cc.png" sx={{ maxWidth: '100%', maxHeight: '100%' }} />
              </FeatureIconContainer>
              <Box sx={{ textAlign: { xs: 'left', md: 'center' }, width: { xs: 'calc(100% - 76px)', md: '100%' } }}>
                <Typography variant="h5" color="primary.main" sx={{ mb: 2, fontWeight: 600 }}>
                  Simple Billing
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  No matter how many items or shipping dates, you'll receive a single consolidated charge per order.
                </Typography>
              </Box>
            </CardContent>
          </FeatureCard>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FeatureCard>
            <CardContent sx={{ p: { xs: 3, md: 4 }, height: '100%', display: 'flex', flexDirection: { xs: 'row', md: 'column' }, alignItems: { xs: 'flex-start', md: 'center' } }}>
              <FeatureIconContainer>
                <Box component="img" src="/images/icons/features/products.png" sx={{ maxWidth: '100%', maxHeight: '100%' }} />
              </FeatureIconContainer>
              <Box sx={{ textAlign: { xs: 'left', md: 'center' }, width: { xs: 'calc(100% - 76px)', md: '100%' } }}>
                <Typography variant="h5" color="primary.main" sx={{ mb: 2, fontWeight: 600 }}>
                  Any Product, Any Service
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  With millions of SKUs, we ensure you can find exactly what you need, from everyday supplies to specialized services.
                </Typography>
              </Box>
            </CardContent>
          </FeatureCard>
        </Grid>
      </Grid>
    </MContainer>
  );
}
